@if (!refreshing) {
  <div>
    <div class="row g-0 align-items-end mb-1">
      <div class="col">
        <strong>{{ patientAttachment.fileName | blankValueDash }}</strong>
      </div>
      <div class="col text-end">
        @if (patientAttachment.fileName) {
          <button class="btn btn-sm btn-secondary" (click)="onDownloadClick($event)">
            <fa-icon [icon]="['fas', 'cloud-download-alt']" /> Download
          </button>
        }
        @if (patientAttachment.pdfGenerationPending) {
          <span>
            Preparing
          </span>
        }
      </div>
    </div>
    <app-pdf-file-viewer
      [pdfFile]="patientAttachment"
      [pdfFileType]="pdfFileType"
      [initialPage]="1"
      [hideRotationControls]="true"
      height="80vh"
      />
  </div>
} @else {
  <mat-spinner />
}
